var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.analyticData && _vm.analyticData.length)?_c('div',{staticClass:"info"},[_c('BarChart',{attrs:{"chartData":_vm.chartData,"options":_vm.chartOptions}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }